import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 66 66"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M28.92 1.686a5.75 5.75 0 0 1 8.132 0l27.233 27.248.205.214a5.755 5.755 0 0 1-.205 7.92L37.052 64.317a5.75 5.75 0 0 1-8.133 0l-5.8-5.804a2.13 2.13 0 1 1 3.014-3.013l2.608 2.61-9.066-33.37-15.18 9.06q.085.137.204.257l3.042 3.043a2.132 2.132 0 0 1-3.013 3.013l-3.042-3.044a5.755 5.755 0 0 1-.001-8.134l2.566-2.569a3 3 0 0 1 4.243 0l.07.07 10.878-6.491 6.129-9.812-.426-.426a3 3 0 0 1-.001-4.242zm5.112 59.62.006-.005L61.2 34.126 23.917 24.078zM24.52 19.853l33.756 9.096L34.038 4.7q-.016-.014-.034-.029z"
    }, null, -1)
  ]))]))
}
export default { render: render }